import { useNavigate } from 'react-router-dom'; // 1. Import useNavigate instead of Link

export default function CampaignHeader({ title }) {
  // 2. Get the navigate function from the hook
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // This tells the router to go back one step in the history
  };

  const brandColor = '#e46809';

  return (
    // 3. UPDATED: Replaced purple border with your brand color
    <header className={`bg-gray-50 dark:bg-gray-800 border-b-4 shadow-sm`} style={{ borderColor: brandColor }}>
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        
        {/* 4. CHANGED: This is now a <button> that uses the navigate function */}
        <button 
          onClick={handleGoBack} 
          className="p-2 -ml-2" 
          aria-label="Go back to the previous page"
          title="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        
        <h1 className="text-xl font-bold text-gray-800 dark:text-gray-100">{title}</h1>
        
        {/* This empty div is a clever trick to keep the title perfectly centered */}
        <div className="w-6" /> 
      </div>
    </header>
  );
}